export default __webpack_public_path__ + "static/media/home_banner_2.8519f144.jpg";